<template>
  <div class="sider_2">
    <div
      class="title"
      v-html="cTitle"
      style="border-bottom: 1px solid rgb(230, 230, 230); margin-bottom: 20px"
    >
      123
    </div>
    <!-- <div class="department">
      <div class="title">
        <div class="tag fl">
          {{ cInfoTitles.title1 }}
        </div>
        <span class="more fr" @click="moreBtn"
          >{{ more }}<i :class="moreTag"></i
        ></span>
      </div>
      <ul :class="ulList">
        <li v-for="item in 20" :key="item">
          <i></i>
          <a :href="cInfos1.link"
            >{{ cInfos1.info }}<span>({{ cInfos1.num }})</span></a
          >
        </li>
      </ul>
    </div> -->
    <div class="department">
      <div class="title">
        <div class="tag fl">
          {{ cInfoTitles.title2 }}
        </div>
        <span class="more fr" @click="moreBtn2"
          >{{ more2 }}<i :class="moreTag2"></i
        ></span>
      </div>
      <ul :class="ulList2">
        <li 
          :class="idx==index?'active':''"
          v-for="(item,idx) in cCitydataarr" 
          :key='idx'
          @click="searchCity(item.siteName,idx)"
          :title="item.siteName"
        >
          <i></i>
          <a style="cursor:pointer;"
            >{{ item.siteName }}<span>({{ item.count }})</span></a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-silder-tjxx",
  components: {},
  props: {
    cTitle: {
      default: "统计信息",
    },
    cInfoTitles: {
      type: Object,
      default: function () {
        return {
          title1: "自治区部门",
          title2: "自治区盟市",
        };
      },
    },
    cInfos1: {
      type: Object,
      default: function () {
        return {
          link: "###",
          info: "内蒙古自治区卫生健康委员会",
          num: 11,
        };
      },
    },
    cInfos2: {
      type: Object,
      default: function () {
        return {
          link: "###",
          info: "自治区部门",
          num: 11,
        };
      },
    },
    cCitydataarr: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      more: "展开",
      more2: "展开",
      moreTag: "down",
      moreTag2: "down",
      ulList: "ulUp",
      ulList2: "ulUp",
      index:-1
    };
  },
  watch: {},
  computed: {},
  methods: {
    moreBtn() {
      if (this.moreTag == "down") {
        this.moreTag = "up";
        this.more = "收起";
        this.ulList = "ulDown";
      } else {
        this.moreTag = "down";
        this.more = "展开";
        this.ulList = "ulUp";
      }
    },
    moreBtn2() {
      if (this.moreTag2 == "down") {
        this.moreTag2 = "up";
        this.more2 = "收起";
        this.ulList2 = "ulDown";
      } else {
        this.moreTag2 = "down";
        this.more2 = "展开";
        this.ulList2 = "ulUp";
      }
    },
    searchCity(item,idx) {
      this.$emit("funcity", item);
      this.index=idx;
      // console.log(this.index)
    },
    // 获取盟市数据
    // async citydata() {
    //   const { data: res } = await this.$http.get(
    //     "/nmsearch/openSearch/getOtherSiteAgg",
    //     {
    //       params: {
    //         searchTag: "other_site",
    //       },
    //     }
    //   );
    //   if (res.state == 200) {
    //     // alert(111)
    //     this.citydataarr=res.data.data;
    //     // console.log(res.data.data);
    //   }
    // },
  },
  created() {
    
  },
  mounted() {},
};
</script>

<style lang='less' scoped>
.fr {
  float: right;
}
.sider_2 {
  width: 100%;
  .title {
    width: 100%;
    height: 24px;
    font-size: 18px;
    padding-bottom: 10px;
    font-weight: bold;
  }
  .department {
    width: 100%;
    // margin-left: 20px;
    margin-bottom: 30px;
    padding-left: 20px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      .tag {
        width: 110px;
        height: 30px;
        background-color: rgb(238, 238, 238);
        color: rgb(1, 82, 147);
        text-align: center;
        line-height: 30px;
      }
      .more {
        display: inline-block;
        width: 55px;
        height: 30px;
        font-size: 14px;
        line-height: 30px;
        cursor: pointer;
        color: rgb(1, 82, 147);
        font-weight: normal;
      }
      i {
        display: inline-block;
        width: 20px;
        height: 20px;
        top: 20%;
        position: relative;
      }
      .up {
        background-image: url(../../assets/img/up.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .down {
        background-image: url(../../assets/img/down.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
    ul {
      margin: 0;
      padding: 0;
      overflow: hidden;

      li {
        display: inline-block;
        width: 330px;
        height: 24px;
        font-size: 14px;
        line-height: 24px;
        i {
          display: inline-block;
          width: 15px;
          height: 15px;
          background-image: url(../../assets/img/pointer.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          top: 10%;
          position: relative;
        }
        a {
          color: #333;
        }
      }
      li:hover {
        background-color: rgb(238, 238, 238);
        a {
          font-weight: bold;
        }
      }
    }
    .ulUp {
      height: 145px;
    }
    .ulDown {
      height: auto;
    }
  }
}
.sider_2 .department ul li.active a{font-weight: bold;}
</style>